import axios from 'axios';

const {
  REACT_APP_API_URL: baseURL,
  REACT_APP_HTACCESS_USERNAME,
  REACT_APP_HTACCESS_PASSWORD
} = process.env;

const client = axios.create({ baseURL });

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.status === 401 &&
      !["/connexion", "/inscription"].includes(window.location.pathname.trim())
    ) {
      localStorage.clear();
      window.location.href = "/connexion";
    } else {
      return Promise.reject(error);
    }
  }
);

export default client;
